<form [formGroup]="form">
  <rask-card
    label="{{atgard.namn}} {{atgard.beteckning}}"
    [size]="4"
    [ngClass]="{'hovering': atgard.isHovering}"
    (mouseover)="atgardService.hoverToggle(atgard, true)"
    (mouseleave)="atgardService.hoverToggle(atgard, false)">
    <ng-container>
      <div class="row justify-content-between px-3">
        <rask-input class="col-2" label="Volym" value="{{atgard.volymAtgard}}" [readonly]="true"></rask-input>
        <rask-input class="col-4" label="Typ" value="{{atgard.atgardstyp}}" [readonly]="true"></rask-input>
        <rask-selector class="col-3"
          label="Åtgärden utförd"
          [values]="optionsAtgardUtford"
          [formatter]="atgardUtfordViewFormatter"
          formControlName="atgardUtford"
          [rule]="validation.utford">
        </rask-selector>
      </div>
      <div class="row justify-content-between px-3">
        <rask-input class="col-3" label="Grot Föreslagen" value="{{atgard.grotuttagProduktionsplanerat ? 'Ja' : 'Nej'}}" [readonly]="true"></rask-input>
        @if (atgard.grotuttagProduktionsplanerat) {
          <rask-simple-selector
            class="col-5"
            label="Grotanpassad avverkning"
            [values]="optionsGrotanpassad"
            bindLabel="value"
            bindValue="key"
            formControlName="grotAnpassad"
            [rule]="validation.grotanpassad"
            [onBeforeChange]="onBeforeChangeGrotanpassad">
          </rask-simple-selector>
        }
        @if (atgard.grotuttagProduktionsplanerat) {
          <rask-input
            class="col-3"
            label="Grotvolym"
            formControlName="grotVolym"
          [rule]="validation.grotvolym"></rask-input>
        }
      </div>
    </ng-container>
  </rask-card>
</form>
